import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ForbiddenPage() {
  const { t } = useTranslation();
  return (
    <div style={shell}>
      <div style={card}>
        <h1 style={{ margin: 0, color: "#b91c1c", fontSize: 28 }}>{t("forbidden.code")}</h1>
        <p style={{ margin: 0, fontSize: 18, color: "#1f2937" }}>{t("forbidden.title")}</p>
        <p style={{ margin: 0, color: "#6b7280", fontSize: 14 }}>
          {t("forbidden.message")}
        </p>
        <Link to="/dashboard" style={{ color: "#0b3a6f", fontSize: 14 }}>
          {t("forbidden.back")}
        </Link>
      </div>
    </div>
  );
}

const shell: React.CSSProperties = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#f4f6f8",
};
const card: React.CSSProperties = {
  background: "#fff",
  padding: 32,
  borderRadius: 12,
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  gap: 12,
  boxShadow: "0 1px 3px rgba(0,0,0,.08)",
};
